export default __webpack_public_path__ + "static/media/extraGuestSnapshot.acf9166b.png";